import styled from "styled-components";

export const Content = styled.div`
    background-color: #020052;
    width: 100%;
    

    @media (max-width: 1919px) {
        background-color: #020052
        
    }

    @media (max-width: 1365px) {
        background-color: #020052;
        
        display: flex;
        flex-direction: column;
        align-items: center;
    }
`;

export const Title = styled.h1`
  font-family: "Rubik";
  font-style: normal;
  font-weight: 700;
  font-size: 1.75rem;
  line-height: 33px;
  text-align: left;
  color: #ffffff;
  margin-left: 5%;
  padding: 100px 0 50px 0;

  @media (max-width: 1365px) {
    font-weight: 700;
    font-size: 20px;
    line-height: 23.7px;
    text-align: center;
  }
`;

export const Cards = styled.div`
    display: flex;
    flex-wrap: wrap;
    
    align-items: left;
    width: 85%;
    margin: auto;
    max-width: 1800px;

    @media (max-width: 1919px) {
      max-width: 1100px;
    }

    @media (max-width: 1365px) {
        flex-direction: column;
        flex-wrap: none;
        height: 100%;
    }
`;

export const Card = styled.div`
    margin: 20px auto;
    align-items: center;
    color: #ffffff;
    padding: 24px;
    border: 3px solid #EF3900;
    border-radius: 16px;

    
`;

export const FDSCard = styled.div`
    margin: 20px auto;
    align-items: center;
`;

export const CardTitle = styled.h2`
  font-family: "Rubik";
  font-style: normal;
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 28px;
  text-align: center;
  text-transform: uppercase;
  margin: 0;
  padding-bottom: 8px;
  border-bottom: 2px solid white;

  @media (max-width: 1919px) {
        
  }

  @media (max-width: 1365px) {
    margin-bottom: 0;
    font-size: 1.25rem;
  }
`;

export const CardContent = styled.ul`

`;
export const ClassInfo = styled.li`

  margin-top: 32px;
  font-weight: 400;
  font-size: 1.7rem;

  >strong {
    font-weight: 1000;
    color: white;
    margin-right: 10px;
  }

  @media (max-width: 1919px) {
    font-size: 1rem;
  }


  @media (max-width: 1365px) {

  }

`;
